import React from "react";
import { localize } from "redux-i18n";
import { ChartJS } from "@components";
import type { AbsenceStatistics } from "@modules/shared/reducer/employee-absences/types";

type Props = $Exact<{
  ...PropsFromLocalize,
  data: AbsenceStatistics,
}>;

export class AbsenceStatisticReportingCompliance extends React.Component<Props> {
  get chartData() {
    const items = this.props.data.reportingCompliance || [];
    return {
      labels: items.map(item => item.description),
      datasets: [
        {
          label: this.props.t("ABSENCE_REPORTING_COMPLIANCE"),
          data: items.map(item => item.value),
        },
      ],
    };
  }

  render() {
    return (
      <ChartJS
        type="doughnut"
        title={this.props.t("ABSENCE_REPORTING_COMPLIANCE")}
        data={this.chartData}
        options={{ animation: false }}
      />
    );
  }
}

export default localize()(AbsenceStatisticReportingCompliance);
